<div class="grid md:grid-cols-7 gap-x-4 sm:grid-cols-1">
  <div class="formgrid  container  col-span-4">
    <div class="field">
      <label
        for="paymentMethod"
        class="is-required"
      >{{"paymentMethod" | translate}}</label>
      <div class="flex flex-wrap gap-4">
        <div class="flex items-center">
          <p-radiobutton
            name="cash"
            [value]="paidByType.Cash"
            [(ngModel)]="purchasePaidData.paidBy"
            inputId="cash"
            (ngModelChange)="onChangePaidByType()"
          />
          <label
            for="cash"
            class="ml-2"
          >{{pidByEnumText[paidByType.Cash]}}</label>
        </div>

        <div class="flex items-center">
          <p-radiobutton
            name="bank"
            [value]="paidByType.Bank"
            [(ngModel)]="purchasePaidData.paidBy"
            inputId="bank"
            (ngModelChange)="onChangePaidByType()"
          />
          <label
            for="bank"
            class="ml-2"
          >{{pidByEnumText[paidByType.Bank]}}</label>
        </div>
      </div>
    </div>

    @if(purchasePaidData.paidBy === paidByType.Bank){
    <div class="field">
      <label
        for=" paidBankType"
        class="is-required"
      >{{"purchaseDetailList.paidBankType" | translate}}
      </label>
      <div class="flex flex-wrap gap-4">
        <div class="flex items-center">
          <p-radiobutton
            name="savedAccount"
            [value]="paidBankTypeEnum.SavedAccount"
            [(ngModel)]="purchasePaidData.paidBankType"
            inputId="savedAccount"
            (ngModelChange)="onChangePaidBankType()"
          />
          <label
            for="savedAccount"
            class="ml-2"
          >{{paidBankTypeEnumText[paidBankTypeEnum.SavedAccount]}}</label>
        </div>

        <div class="flex items-center">
          <p-radiobutton
            name="customAccount"
            [value]="paidBankTypeEnum.CustomAccount"
            [(ngModel)]="purchasePaidData.paidBankType"
            inputId="customAccount"
            (ngModelChange)="onChangePaidBankType()"
          />
          <label
            for="customAccount"
            class="ml-2"
          >{{paidBankTypeEnumText[paidBankTypeEnum.CustomAccount]}}</label>
        </div>

        <div class="flex items-center">
          <p-radiobutton
            name="paidBankPromptpay"
            [value]="paidBankTypeEnum.Promptpay"
            [(ngModel)]="purchasePaidData.paidBankType"
            inputId="paidBankPromptpay"
            (ngModelChange)="onChangePaidBankType()"
          />
          <label
            for="paidBankPromptpay"
            class="ml-2"
          >{{paidBankTypeEnumText[paidBankTypeEnum.Promptpay]}}
          </label>
        </div>
      </div>
    </div>
    }


    @if(purchasePaidData.paidBy === paidByType.Bank && purchasePaidData.paidBankType === paidBankTypeEnum.SavedAccount){
    <div class="field">
      <label
        for="paidToMemberBankId"
        class="is-required"
      >{{'bankAccount' | translate}}</label>
      <shared-member-bank-dropdown
        isPrimitive
        id="paidToMemberBankId"
        name="paidToMemberBankId"
        [(ngModel)]="purchasePaidData.paidToMemberBankId"
        [memberId]="member?.id || undefined"
        [placeholder]="'placeholderInput' | translate: { placeholder: 'bankAccount' | translate }"
        required
      >
      </shared-member-bank-dropdown>
    </div>
    }


    @if(purchasePaidData.paidBy === paidByType.Bank && purchasePaidData.paidBankType === paidBankTypeEnum.CustomAccount){
    <div class="grid  gap-x-4 grid-cols-1 items-center md:grid-cols-2">
      <div class="field">
        <label
          for="bankAccount"
          class="is-required"
        >{{"bank" | translate}}</label>
        <lib-dynamic-dropdown
          [list]="bankList"
          isPrimitive
          id="bankAccount"
          name="bankAccount"
          [(ngModel)]="purchasePaidData.paidToBankId"
          [placeholder]="'placeholderSelect' | translate: {placeholder: 'bank' | translate} "
          required
        >
          <ng-template
            dropdownSelectedItemTpl
            let-selectedOption
          >
            <div class="flex items-center gap-2">
              <img
                [src]="selectedOption.imageUrl"
                class="w-[18px]"
              />
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template
            dropdownItemTpl
            let-item
          >
            <div class="flex items-center gap-2">
              <img
                [src]="item.imageUrl"
                class="w-[18px]"
              />
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </lib-dynamic-dropdown>

      </div>
      <div class="field">
        <label
          for="branch"
          class="is-required"
        >{{"branch" | translate}}</label>
        <input
          type="text"
          pInputText
          id="branch"
          name="branch"
          [(ngModel)]="purchasePaidData.paidToBankBranchName"
          [placeholder]="'placeholderInput' | translate: {placeholder: 'branch' | translate} "
          required
        />
      </div>
      <div class="field">
        <label
          for="accountNumber"
          class="is-required"
        >{{"accountNumber" | translate}}</label>
        <input
          type="text"
          pInputText
          id="accountNumber"
          name="accountNumber"
          [(ngModel)]="purchasePaidData.paidToBankAccountNo"
          [pKeyFilter]="'int'"
          required
          [placeholder]="'placeholderInput' | translate: {placeholder: 'accountNumber' | translate}"
        />
      </div>
      <div class="field">
        <!-- <label for="isSaveNext">{{"purchaseDetailList.saveItForNextTime" | translate}}</label> -->
        <div class="flex items-center gap-1 md:mt-6">
          <p-checkbox
            inputId="isSaveNext"
            name="isSaveNext"
            [(ngModel)]="purchasePaidData.rememberBank"
            [binary]="true"
          />
          <label
            for="isSaveNext"
            class="ml-2"
          >{{"purchaseDetailList.saveItForNextTime" | translate}}</label>

        </div>

      </div>
    </div>
    }

    @if(purchasePaidData.paidBy === paidByType.Bank && purchasePaidData.paidBankType === paidBankTypeEnum.Promptpay){

    <div class="field">
      <label
        for="promptpay"
        class="is-required"
      >{{"purchaseDetailList.promptpay" | translate}}</label>
      <input
        type="text"
        pInputText
        id="promptpay"
        name="promptpay"
        [(ngModel)]="purchasePaidData.paidToPromptpay"
        [placeholder]="'placeholderInput' | translate: {placeholder: 'purchaseDetailList.promptpay' | translate} "
        required
      />

    </div>
    }
  </div>

  @if(purchasePaidData.paidBy === paidByType.Bank){
  <div class="formgrid _g-border-left-dashed col-span-3">
    <div class="_g-detail-wrapper">
      <div class="_wallpaper-info ">
        <div class="flex _g-content-detail">
          <span class="lg:w-2/5 w-1/3 font-semibold">{{"paymentMethod" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">{{pidByEnumText[purchaseData.paidBy]}} </span>
        </div>

        @if(purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType !== paidBankTypeEnum.Promptpay){
        @if(purchaseData.paidBy === paidByEnum.Bank){
        <div class="flex _g-content-detail">
          <span class="lg:w-2/5 w-1/3  font-semibold">{{ "purchaseDetailList.paidBankType" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">
            {{paidBankTypeEnumText[purchaseData.paidBankType]}}
          </span>
        </div>
        }

        <div class="flex _g-content-detail">
          <span class="lg:w-2/5 w-1/3 font-semibold">{{ "bank" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">
            @if(purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount){
            {{!purchaseData.paidToBankId ? '-' : purchaseData.paidToBankId.translations| translations:'name'}}

            } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{bankData.translations | translations:'name'}}
            }@else {
            -
            }

          </span>
        </div>

        <div class="flex  _g-content-detail">
          <span class="lg:w-2/5 w-1/3 font-semibold">{{ "branch" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">

            @if(purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount){
            {{purchaseData.paidToBankBranchName ? purchaseData.paidToBankBranchName : '-'}}
            } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{purchaseData.paidToMemberBankId ? purchaseData.paidToMemberBankId.bankBranchName : '-'}}
            }@else {
            -
            }
          </span>

        </div>
        <div class="flex  _g-content-detail">
          <span class="lg:w-2/5 w-1/3 font-semibold">{{ "accountNumber" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">
            @if(purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount){
            {{purchaseData.paidToBankAccountNo}}
            } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{purchaseData.paidToMemberBankId ? purchaseData.paidToMemberBankId.bankAccountNo : '-'}}
            }@else {
            -
            }

          </span>
        </div>
        }

        @if(purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.Promptpay){
        <div class="flex _g-content-detail">
          <span class="lg:w-2/5 w-1/3  font-semibold">{{"purchaseDetailList.promptpay" | translate }}: </span>
          <span class="lg:w-3/5 w-2/3">
            {{purchaseData.paidToPromptpay ? purchaseData.paidToPromptpay : '-'}}

          </span>
        </div>
        }
      </div>

      <div class="formgrid  grid-cols-1 lg:grid-cols-4 mt-4">
        <div class="field col-span-2">
          <label
            for="file1"
            class="is-required"
          >{{"slipImage" | translate}}</label>
          <lib-file-image-upload
            aspectRatio="1/1"
            name="file1"
            [(ngModel)]="fileImage"
            required
            [acceptFileType]="['.png','.jpg', '.jpeg', '.svg']"
          />
        </div>
      </div>

    </div>
  </div>
  }
</div>